import { render } from "./CreateAccountModal.vue?vue&type=template&id=60d03220"
import script from "./CreateAccountModal.vue?vue&type=script&lang=ts"
export * from "./CreateAccountModal.vue?vue&type=script&lang=ts"
script.render = render

export default script